import { Connection, Edge } from "@xyflow/react";

export default function isConnectingTwoZapSteps(edge: Edge | Connection) {
  const sourceStartsWithZap = edge.source?.startsWith("zap");
  const targetStartsWithZap = edge.target?.startsWith("zap");

  return sourceStartsWithZap && targetStartsWithZap;
}
